import { render, staticRenderFns } from "./PersonelVacationView.vue?vue&type=template&id=2ad344f4&"
import script from "./PersonelVacationView.vue?vue&type=script&lang=js&"
export * from "./PersonelVacationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports